import sdl from '@jds/react-generated-sdl/JDSAccordion';
import type { JDSAccordionProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, AccordionPanelProps } from '../logic';

const Component = (props: AccordionPanelProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    expandedPanel = false,
    disabled = false,
    showDivider = true,
    iconType = 'chevron',
    buttonAriaLabel = 'Toggle accordion',
    _ariaExpanded = props.expandedPanel?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      expandedPanel,
      disabled,
      showDivider,
      iconType,
      buttonAriaLabel,
      _ariaExpanded,
      ...rest
    },
    'JDSAccordion',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const AccordionPanel = withLogic(Component) as React.FC<AccordionPanelProps> & {
  slotName?: string;
};

AccordionPanel.displayName = 'AccordionPanel';
AccordionPanel.slotName = 'jds_accordion';

export { AccordionPanel, type JDSAccordionProps };
